<div [ngClass]="dialogConfiguration.type" class="dialog-top-icon">
  @switch (dialogConfiguration.type) {
    @case (types.ERROR) {
      <mat-icon data-tfa="top-icon_error">highlight_off</mat-icon>
    }
    @case (types.WARN) {
      <mat-icon data-tfa="top-icon_warn">warning_amber</mat-icon>
    }
    @case (types.SUCCESS) {
      <mat-icon data-tfa="top-icon_success">check_circle_outlined</mat-icon>
    }
    @case (types.INFO) {
      <mat-icon data-tfa="top-icon_info">info_outlined</mat-icon>
    }
  }
</div>

@if (dialogConfiguration.title) {
  <div class="dialog-header">
    <h1 [ngClass]="dialogConfiguration.type" color="primary" mat-dialog-title>
      {{ dialogConfiguration.title }}
    </h1>
    @if (!dialogConfiguration.noCloseButton && !dialogConfiguration.disableClose) {
      <button
        [mat-dialog-close]="false"
        aria-label="fermer"
        class="icone-fermer"
        data-tfa="bouton-fermer"
        mat-mini-fab
        matTooltip="fermer"
      >
        <mat-icon data-tfa="icon-fermer-modale">close</mat-icon>
      </button>
    }
  </div>
}

@if (dialogConfiguration.projectionDansUnMatDialogContent) {
  @if (dialogConfiguration.templateRef) {
    <div class="content" mat-dialog-content>
      <ng-container
        [ngTemplateOutlet]="dialogConfiguration.templateRef"
      ></ng-container>
    </div>
  }
  @if (dialogConfiguration.component) {
    <div
      class="content"
      id="componentHost_{{id}}"
      mat-dialog-content
    ></div>
  }
  @if (dialogConfiguration.text) {
    <div
      [innerHTML]="dialogConfiguration.text"
      class="content"
      mat-dialog-content
    ></div>
  }
  @if (dialogConfiguration.buttons && dialogConfiguration.buttons.length > 0) {
    <div
      class="dialogButton"
      mat-dialog-actions
    >
      @for (button of dialogConfiguration.buttons; track button) {
        @if (button.type === buttonTypes.ANNULER) {
          <button
            (click)="onClick(button)"
            color="{{ button.color ?? 'accent' }}"
            data-tfa="Annuler"
            mat-raised-button
          >
            <mat-icon data-tfa="cancel">{{ button.svgIcon }}</mat-icon>
            <span>{{ button.text ? button.text : "Annuler" }}</span>
          </button>
        }
        @if (button.type === buttonTypes.CONFIRMER) {
          <button
            (click)="onClick(button)"
            [attr.data-tfa]="button.text? button.text: 'Confirmer'"
            [disabled]="isDisabled(button)"
            color="{{ button.color ?? 'primary' }}"
            mat-raised-button
          >
            <mat-icon data-tfa="done">{{ button.svgIcon }}</mat-icon>
            <span>{{ button.text ? button.text : "Confirmer" }}</span>
          </button>
        }
      }
    </div>
  }
} @else {
  @if (dialogConfiguration.templateRef) {
    @if (dialogConfiguration.templateRef) {
      <ng-container [ngTemplateOutlet]="dialogConfiguration.templateRef"></ng-container>
    }
  }
  @if (dialogConfiguration.component) {
    @if (dialogConfiguration.component) {
      <div
        class="content"
        id="componentHost_{{id}}"
      ></div>
    }
  }
  @if (dialogConfiguration.text) {
    <div
      [innerHTML]="dialogConfiguration.text"
      class="content"
    ></div>
  }
  @if (dialogConfiguration.buttons && dialogConfiguration.buttons.length > 0) {
    <div
      class="dialogButton"
      mat-dialog-actions
    >
      @for (button of dialogConfiguration.buttons; track button) {
        @if (button.type === buttonTypes.ANNULER) {
          <button
            (click)="onClick(button)"
            color="{{ button.color ?? 'accent' }}"
            data-tfa="Annuler"
            mat-raised-button
          >
            <mat-icon data-tfa="cancel">{{ button.svgIcon }}</mat-icon>
            <span>{{ button.text ? button.text : "Annuler" }}</span>
          </button>
        }
        @if (button.type === buttonTypes.CONFIRMER) {
          <button
            (click)="onClick(button)"
            [attr.data-tfa]="button.text? button.text: 'Confirmer'"
            [disabled]="isDisabled(button)"
            color="{{ button.color ?? 'primary' }}"
            mat-raised-button
          >
            <mat-icon data-tfa="done">{{ button.svgIcon }}</mat-icon>
            <span>{{ button.text ? button.text : "Confirmer" }}</span>
          </button>
        }
      }
    </div>
  }
}

